import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

type Tone = 'complete' | 'pending' | 'idle';

export type StatusBadgeProps = {
  tone: Tone;
  label: string;
  size?: 'sm' | 'md';
  stretch?: boolean;
};

export const StatusBadge = ({ tone, label, size = 'md', stretch = false }: StatusBadgeProps) => {
  const theme = useTheme();

  const tones: Record<Tone, { bg: string; fg: string; dot: string }> = {
    complete: {
      bg: theme.palette.success.light,
      fg: theme.palette.success.main,
      dot: theme.palette.success.main,
    },
    pending: {
      bg: theme.palette.warning.light,
      fg: theme.palette.warning.main,
      dot: theme.palette.warning.main,
    },
    idle: {
      bg: theme.palette.grey[100],
      fg: theme.palette.text.secondary,
      dot: theme.palette.text.disabled,
    },
  };
  const t = tones[tone];

  return (
    <Box
      component="span"
      sx={{
        display: stretch ? 'flex' : 'inline-flex',
        width: stretch ? '100%' : undefined,
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: stretch ? 'center' : 'flex-start',
        gap: 0.75,
        backgroundColor: t.bg,
        color: t.fg,
        borderRadius: 999,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        fontSize: size === 'sm' ? 11 : 12,
        py: size === 'sm' ? 0.25 : 0.5,
        pl: size === 'sm' ? 0.75 : 1,
        pr: size === 'sm' ? 1 : 1.25,
        lineHeight: 1.4,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: t.dot,
          flexShrink: 0,
        }}
      />
      {label}
    </Box>
  );
};
